(function() {
  "use strict";
  angular.module("marketPlace.referral").controller("ReferralController", referralController);

  referralController.$inject = ["$scope", "$uibModalInstance", "$log", "Referral", "toastr", "SITE_NAME"];

  function referralController($scope, $uibModalInstance, $log, Referral, toastr, SITE_NAME) {
    const vm = this;
    vm.siteName = SITE_NAME;
    vm.sendReferral = sendReferral;
    vm.cancel = cancel;
    vm.referral = new Referral();
    vm.form = {};
    vm.errors = {};

    function sendReferral() {
      $scope.$broadcast("show-errors-check-validity");

      if (vm.form.$invalid) {
        return;
      }

      vm.referral.$save(
        function() {
          closeModal();
        },
        function(resp) {
          $log.debug("Could not send referral");

          if (resp.data && resp.status !== 500) {
            angular.forEach(resp.data, function(errors, field) {
              $log.debug(field + " : " + errors);
              try {
                vm.form[field].$setValidity("server", false);
                vm.errors[field] = errors.join(", ");
              } catch (e) {
                $log.error(resp.status + ": " + resp.statusText);
                if (angular.isArray(errors)) {
                  errors = errors.join(", ");
                }
                vm.errors.non_field_errors = errors;
              }
            });
          } else {
            $log.error(resp.status + ": " + resp.statusText);
            vm.errors.non_field_errors = "Could not send referral, please try again";
          }

          $scope.$broadcast("show-errors-check-validity");
        }
      );
    }

    function closeModal() {
      vm.saving = false;
      $scope.$broadcast("show-errors-reset");
      $uibModalInstance.result.then(function() {
        toastr.success("Referral sent");
      });
      $uibModalInstance.close(true);
    }

    function cancel() {
      $scope.$broadcast("show-errors-reset");
      $uibModalInstance.dismiss("cancel");
    }
  }
})();
